/** socket events */

const events = {
	MESSAGE: 'message',
	UPDATE: 'update',
	DISCONNECTION: 'disconnection',
};

export default events;
